import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function MobileMenu() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className='md:hidden'>
            {/* Hamburger Button */}
            <button
                className='flex flex-col space-y-1 p-2 rounded-md border'
                onClick={() => setIsOpen(!isOpen)}
            >
                {isOpen ? "✖" : "☰"}
            </button>

            {/* Mobile Nav Menu */}
            {isOpen && (
                <nav className='absolute top-16 left-0 w-full bg-white shadow-md p-4 flex flex-col space-y-4 z-50'>
                    <Link className='font-semibold' to='/groups'>Groups</Link>
                    <Link className='font-semibold' to='/about'>About</Link>
                    <Link className='font-semibold' to='/more-info'>Answers</Link>
                    <Link className='font-semibold' to='/terms'>Terms</Link>
                    <Link className='font-semibold' to='/demos'>Demos</Link>
                    <Link className='font-semibold' to='/contest'>Contest</Link>
                </nav>
            )}
        </div>
    );
}
